import GridLayout from 'components/Content/ProductListLayout/GridLayout/GridLayout';

export default GridLayout;
